// Icone dei servizi e della banda laterale (SVG: uguali su tutti i computer)
const PERCORSI = {
  chiamata: <path d="M5 4h4l2 5-2.5 1.5a11 11 0 0 0 5 5L15 13l5 2v4a2 2 0 0 1-2 2A16 16 0 0 1 3 6a2 2 0 0 1 2-2z" />,
  euro: (
    <>
      <circle cx="12" cy="12" r="9" />
      <path d="M15.5 8.6A4.2 4.2 0 0 0 12.4 7.5c-2.4 0-4 1.9-4 4.5s1.6 4.5 4 4.5a4.2 4.2 0 0 0 3.1-1.1M6.8 10.6h6M6.8 13.4h6" />
    </>
  ),
  calendario: (
    <>
      <rect x="3.5" y="5" width="17" height="15" rx="2" />
      <path d="M3.5 10h17M8 3v4M16 3v4" />
    </>
  ),
  grafico: (
    <>
      <path d="M4 20h16" />
      <path d="M6 16v-3M10 16V9M14 16v-5M18 16V6" />
      <path d="M5 11l5-4 4 3 5-5" />
    </>
  ),
  casa: (
    <>
      <path d="M3.5 11.2L12 4l8.5 7.2" />
      <path d="M5.5 9.8V20h13V9.8" />
      <path d="M10 20v-5.5h4V20" />
    </>
  ),
  calcolatrice: (
    <>
      <rect x="5" y="3" width="14" height="18" rx="2" />
      <rect x="8" y="6" width="8" height="3.2" rx="0.6" />
      <path d="M8.5 13h.01M12 13h.01M15.5 13h.01M8.5 16.5h.01M12 16.5h.01M15.5 16.5h.01" strokeWidth="2.2" />
    </>
  ),
  grafico_salita: (
    <>
      <path d="M3.5 20.5h17" />
      <path d="M4 16l5-5 4 3.5L20 7" />
      <path d="M15 7h5v5" />
    </>
  ),
  ingranaggio: (
    <>
      <circle cx="12" cy="12" r="3" />
      <path d="M19.4 15a1.7 1.7 0 0 0 .3 1.8l.1.1a2 2 0 1 1-2.8 2.8l-.1-.1a1.7 1.7 0 0 0-1.8-.3 1.7 1.7 0 0 0-1 1.5V21a2 2 0 1 1-4 0v-.1a1.7 1.7 0 0 0-1.1-1.5 1.7 1.7 0 0 0-1.8.3l-.1.1a2 2 0 1 1-2.8-2.8l.1-.1a1.7 1.7 0 0 0 .3-1.8 1.7 1.7 0 0 0-1.5-1H3a2 2 0 1 1 0-4h.1a1.7 1.7 0 0 0 1.5-1.1 1.7 1.7 0 0 0-.3-1.8l-.1-.1a2 2 0 1 1 2.8-2.8l.1.1a1.7 1.7 0 0 0 1.8.3H9a1.7 1.7 0 0 0 1-1.5V3a2 2 0 1 1 4 0v.1a1.7 1.7 0 0 0 1 1.5 1.7 1.7 0 0 0 1.8-.3l.1-.1a2 2 0 1 1 2.8 2.8l-.1.1a1.7 1.7 0 0 0-.3 1.8V9a1.7 1.7 0 0 0 1.5 1H21a2 2 0 1 1 0 4h-.1a1.7 1.7 0 0 0-1.5 1z" />
    </>
  ),
  anagrafiche: (
    <>
      <path d="M4 20.5V6.5L12 3.5l8 3v14" />
      <path d="M2.5 20.5h19" />
      <path d="M8.5 9.5h2M13.5 9.5h2M8.5 13h2M13.5 13h2" />
      <path d="M10.5 20.5v-4h3v4" />
    </>
  ),
  cestino: (
    <>
      <path d="M4 7h16" />
      <path d="M9 7V4.5h6V7" />
      <path d="M6.2 7l.9 12.2a1.5 1.5 0 0 0 1.5 1.3h6.8a1.5 1.5 0 0 0 1.5-1.3L17.8 7" />
      <path d="M10 11v5.5M14 11v5.5" />
    </>
  ),
  lucchetto: (
    <>
      <rect x="5" y="11" width="14" height="9" rx="2" />
      <path d="M8 11V8a4 4 0 0 1 8 0v3" />
    </>
  ),
};

export default function IconaServizio({ icona, dimensione = 20, colore = 'currentColor', className }) {
  return (
    <svg width={dimensione} height={dimensione} viewBox="0 0 24 24" fill="none" stroke={colore}
      strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true" className={className}>
      {PERCORSI[icona] || <circle cx="12" cy="12" r="8" />}
    </svg>
  );
}
